export default __webpack_public_path__ + "static/media/confirmationCircle1Dark.4cd5747a.svg";